import { ActionReducerMapBuilder } from "@reduxjs/toolkit";
import { DealerSliceState } from "../types";
import { addCrudExtraReducers } from "./crud";
import { addListExtraReducers } from "./list";
import { addReportsExtraReducers } from "./reports";

export const registerDealerExtraReducers = (
  builder: ActionReducerMapBuilder<DealerSliceState>,
) => {
  addListExtraReducers(builder);
  addCrudExtraReducers(builder);
  addReportsExtraReducers(builder);
};
